import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import {
  CUSTOMS,
  LABEL,
  OVERVIEW,
  PACKAGE,
  RECEIVER,
  SHIPPER,
  PAYMENT,
  PAYMENT_FAILURE,
} from '~/basket/model/constants'

import { PackagePage } from './pages/package/PackagePage'
import { ParcelshopPaymentPage } from './pages/parcelshop_payment/ParcelshopPaymentPage'
import { WarnBeforeLeaving } from './components/WarnBeforeLeavingRoute'
import { Page } from '~/components/Page'
import { utmQueryString } from '~/util/utmQueryString'
import { ParcelShopService } from '~/account/model/reducer'
import { withParcelShopService } from '~/account/view/components/withParcelShopService'
import { PaymentFailure } from './pages/payment/PaymentFailure'

const ReceiverPage = lazy(() =>
  import('./pages/receiver/Receiver').then((module) => ({ default: module.ReceiverPage }))
)
const ShipperPage = lazy(() => import('./pages/shipper/Shipper').then((module) => ({ default: module.ShipperPage })))
const CustomsPage = lazy(() => import('./pages/customs/Customs').then((module) => ({ default: module.CustomsPage })))
const OverviewRoutes = lazy(() =>
  import('./pages/overview/Routes').then((module) => ({ default: module.OverviewRoutes }))
)
const Label = lazy(() => import('./pages/label/Label').then((module) => ({ default: module.Label })))

export const BasketRoutes = withParcelShopService(ParcelShopService.OTC)(() => (
  <Page testId="page-frame">
    <Routes>
      <Route path={PACKAGE} element={<PackagePage />} />
      <Route
        path={`${RECEIVER}/*`}
        element={
          <WarnBeforeLeaving context="shipment">
            <ReceiverPage />
          </WarnBeforeLeaving>
        }
      />

      <Route
        path={SHIPPER}
        element={
          <WarnBeforeLeaving context="shipment">
            <ShipperPage />
          </WarnBeforeLeaving>
        }
      />

      <Route
        path={CUSTOMS}
        element={
          <WarnBeforeLeaving context="shipment">
            <CustomsPage />
          </WarnBeforeLeaving>
        }
      />

      <Route path={OVERVIEW}>
        <Route index path="*" element={<OverviewRoutes />} />
      </Route>
      <Route path={`${PAYMENT}/*`} element={<ParcelshopPaymentPage />} />
      <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />
      <Route path={LABEL} element={<Label />} />
      <Route index element={<Navigate to={{ pathname: PACKAGE, search: utmQueryString() }} />} />
    </Routes>
  </Page>
))
